import { User } from '../types';
import { DEMO_USERS, DEMO_PASSWORD } from './mockData';

const STORAGE_KEY = 'demo_current_user';

/**
 * Mock Authentication Service for demo mode
 */
export class MockAuthService {
  
  async signIn(email: string, password: string): Promise<{ isSignedIn: boolean; user: User | null }> {
    // Simulate network delay
    await this.delay(500);

    // Check password
    if (password !== DEMO_PASSWORD) {
      throw new Error('Incorrect password. Use "demo123" for demo accounts.');
    }

    // Find user by email
    const user = DEMO_USERS.find(u => u.email.toLowerCase() === email.toLowerCase());
    
    if (!user) {
      throw new Error(`User not found. Try: employee@demo.com, manager@demo.com, hradmin@demo.com, or superadmin@demo.com`);
    }

    // Store in localStorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(user));

    return { isSignedIn: true, user };
  }

  async signOut(): Promise<void> {
    await this.delay(200);
    localStorage.removeItem(STORAGE_KEY);
  }

  async getCurrentUser(): Promise<User | null> {
    await this.delay(100);
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored) as User;
    }
    return null;
  }

  async resetPassword(email: string): Promise<void> {
    await this.delay(300);
    const user = DEMO_USERS.find(u => u.email.toLowerCase() === email.toLowerCase());
    if (!user) {
      throw new Error('User not found');
    }
    console.log(`[Demo Mode] Password reset email would be sent to: ${email}`);
  }

  async confirmResetPassword(email: string, code: string, newPassword: string): Promise<void> {
    await this.delay(300);
    console.log(`[Demo Mode] Password reset confirmed for: ${email}`);
  }

  private delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}

export const mockAuthService = new MockAuthService();
